<div class="layout-topbar">
	<div class="layout-topbar-wrapper">
		<div class="layout-topbar-right">
			<div class="text-xl font-bold ml-6" [ngClass]="dynamicTitle" *ngIf="!onExtendedMobile()">
				{{ titleId | translate }}
			</div>

			<ul class="layout-topbar-actions">
				<!--<p-toggleButton [(ngModel)]="enableBeta" onLabel="{{ 'BETA_ACTIVE' | translate }}"//TOREMOVE in futuro
					offLabel="{{ 'BETA_DISACTIVE' | translate }}"
					[pTooltip]="enableBeta ? ('DISABLING_BETA' | translate) : ('ABILITY_BETA' | translate)"
					tooltipEvent="hover" tooltipPosition="bottom" (click)="goToOldCameConnect()" />-->
				<button *ngIf="iconNotificationMaintenance()" id="btn-topbar-maintenance" pButton pRipple
					class="p-button-primary p-button-text hover:surface-400 text-color"
					(click)="viewNotificationMaintenance()">
					<i class="pi cm-mail text-2xl py-1"></i>
				</button>

				<app-notificationlist *ngIf="showNotificationList()"></app-notificationlist>

				<li #profile class="topbar-item user-profile" [ngClass]="{'active-topmenuitem':getMain(profile)}">
					<!-- [ngClass]="{'active-topmenuitem':serviceMain.activeTopbarItem === profile}" -->
					<button pButton pRipple id="btn-topbar-profile"
						class="p-button-primary p-button-text hover:surface-400 text-color shadow-none h-full px-3 py-1 gap-3 cursor-pointer"
						#toggleButton (click)="onTopbarItemClick($event,profile)">
						<!-- (click)="serviceMain.onTopbarItemClick($event,profile)"> -->
						<i class="pi text-3xl cm-user"></i>
						<div *ngIf="showInfoAvatar" class="profile-info flex flex-column">
							<div class="text-0">{{ getCurrentRole() }}</div>
							<div class="font-semibold text-0">{{ getUsername() }}</div>
						</div>
					</button>

					<ul class="fadeInDown border-round-xl">
						<li class="layout-submenu-header border-round-top-xl">
							<i [class]="getMenuTheme() === 'dim' ? 'text-900' : 'text-0'" class="pi text-3xl cm-user"></i>
							<div class="profile-info">
								<h6 [class]="getMenuTheme() === 'dim' ? 'text-900' : 'text-0'">{{ getUsername() }}</h6>
								<label [class]="getMenuTheme() === 'dim' ? 'text-900' : 'text-0'">{{ currentUser.Email
									}}</label>
							</div>
						</li>
						<li role="menuitem" *ngIf="showUserProfile()">
							<a (click)="userProfile()">
								<i class="pi text-3xl cm-cog"></i>
								<h6>{{ getProfileStdStr() }}</h6>
							</a>
						</li>
						<li role="menuitem">
							<a href="#" (click)="logout()">
								<i class="pi text-3xl cm-logout"></i>
								<h6>{{ 'LOGOUT' | translate}}</h6>
							</a>
						</li>
					</ul>
				</li>
			</ul>
		</div>
	</div>
</div>